// 商品データをグローバル変数として保持
let productModalData = null;
let modalOptisPrice = 0;

// 初期化関数
function initProductModal(productData) {
  productModalData = productData;
  console.log('Product modal initialized with data:', productModalData);
  
  // 商品データが設定された後に価格更新イベントを設定
  setupMainProductPriceUpdate();
}

// モーダルを開く
function openProductModal() {
  console.log('=== Opening Product Modal ===');
  
  const modal = document.getElementById('productModal');
  if (!modal) {
    console.error('Modal element not found');
    return;
  }
  
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
  
  console.log('Calling copyOptisOptionsToModal...');
  copyOptisOptionsToModal();
  
  console.log('Calling setInitialPrice...');
  setInitialPrice();
}

// モーダルを閉じる
function closeProductModal() {
  console.log('=== Closing Modal and Syncing ===');
  
  const modal = document.getElementById('productModal');
  if (modal) {
    // モーダル内の全てのOPTIS選択値を取得
    const modalSelects = document.querySelectorAll('#modalOptisContainer select[name^="po_"]');
    console.log('Modal OPTIS selects found:', modalSelects.length);
    
    modalSelects.forEach((modalSelect, index) => {
      const selectName = modalSelect.name;
      const selectedValue = modalSelect.value;
      
      console.log(`Modal select ${index}: name="${selectName}", value="${selectedValue}"`);
      
      if (selectedValue) {
        // 元のページの対応するセレクトを探す
        const mainSelects = document.querySelectorAll(`select[name="${selectName}"]`);
        
        mainSelects.forEach(mainSelect => {
          if (!mainSelect.closest('#modalOptisContainer')) {
            console.log('Updating main select to:', selectedValue);
            
            // 値を更新
            mainSelect.value = selectedValue;
            
            // 表示を更新
            const mainDropdown = mainSelect.closest('.po-option--dropdown-menu-container');
            if (mainDropdown) {
              // 選択されたオプションを探す
              const allOptions = mainDropdown.querySelectorAll('.po-dropdown-option');
              
              allOptions.forEach(opt => {
                const optValue = opt.getAttribute('data-value');
                if (optValue === selectedValue) {
                  // selected クラスを更新
                  allOptions.forEach(o => o.classList.remove('selected'));
                  opt.classList.add('selected');
                  
                  // 表示テキストを更新
                  const mainDisplay = mainDropdown.querySelector('.po-dropdown-selected-option');
                  if (mainDisplay) {
                    const optDesc = opt.querySelector('.po_description');
                    if (optDesc) {
                      mainDisplay.innerHTML = optDesc.innerHTML;
                      console.log('Main display updated');
                    }
                  }
                }
              });
            }
          }
        });
      }
    });
    
    modal.classList.remove('active');
  }
  
  document.body.style.overflow = '';
  
  // 価格を更新
  setTimeout(() => {
    console.log('Updating main price after sync...');
    updateMainProductPrice();
  }, 500);
  
  console.log('=== Modal Closed ===');
}

// オーバーレイクリックで閉じる
function closeModalOnOverlay(event) {
  if (event.target.id === 'productModal') {
    closeProductModal();
  }
}

// 初期価格を設定
function setInitialPrice() {
  console.log('=== Setting Initial Price ===');
  
  if (!productModalData) {
    console.error('productModalData is not available');
    return;
  }
  
  let basePrice = 0;
  
  if (productModalData.selected_or_first_available_variant && productModalData.selected_or_first_available_variant.price) {
    basePrice = productModalData.selected_or_first_available_variant.price;
  } else if (productModalData.variants && productModalData.variants.length > 0) {
    basePrice = productModalData.variants[0].price;
  }
  
  const priceElement = document.getElementById('modalTotalPrice');
  if (priceElement && basePrice > 0) {
    priceElement.textContent = 
      new Intl.NumberFormat('ja-JP').format(basePrice / 100);
  }
  
  setTimeout(() => {
    updateModalTotalPrice();
  }, 300);
}

// OPTISオプションをモーダルにコピー
function copyOptisOptionsToModal() {
  console.log('=== Copying OPTIS to Modal ===');
  
  const modalContainer = document.getElementById('modalOptisContainer');
  
  if (!modalContainer) {
    console.error('Modal OPTIS container not found');
    return;
  }
  
  // イベント設定フラグはリセットしない(一度設定したら保持)
  // modalContainer.removeAttribute('data-events-setup');
  
  // 既存のコンテンツを完全に削除
  while (modalContainer.firstChild) {
    modalContainer.removeChild(modalContainer.firstChild);
  }
  
  console.log('Modal container cleared');
  
  // 元のページのOPTIS要素を取得(モーダル外のもののみ)
  const optisElements = Array.from(document.querySelectorAll('[id^="po_stack"]')).filter(el => 
    !el.closest('#modalOptisContainer') && !el.closest('#productModal')
  );
  
  console.log('OPTIS elements to copy:', optisElements.length);
  
  optisElements.forEach((element, index) => {
    console.log(`Copying element ${index}:`, element.id);
    
    const clone = element.cloneNode(true);
    
    // IDを変更
    const originalId = clone.id;
    clone.id = originalId + '_modal';
    
    // 内部要素のIDも変更
    const innerElements = clone.querySelectorAll('[id]');
    innerElements.forEach(inner => {
      inner.id = inner.id + '_modal';
    });
    
    modalContainer.appendChild(clone);
  });
  
  console.log('Elements copied to modal');
  
  // 元のページの現在の選択状態をモーダルに反映
  setTimeout(() => {
    syncMainSelectionsToModal();
  }, 500);
}

// 元のページの選択状態をモーダルに同期
function syncMainSelectionsToModal() {
  console.log('=== Syncing Main Selections to Modal ===');
  
  const modalContainer = document.getElementById('modalOptisContainer');
  if (!modalContainer) {
    console.error('Modal container not found');
    return;
  }
  
  // 元のページのOPTIS選択値を取得(モーダル外のもののみ)
  const mainSelects = Array.from(document.querySelectorAll('select[name^="po_"]')).filter(select =>
    !select.closest('#modalOptisContainer') && !select.closest('#productModal')
  );
  
  console.log('Main selects found:', mainSelects.length);
  
  mainSelects.forEach((mainSelect, index) => {
    const selectName = mainSelect.name;
    const selectedValue = mainSelect.value;
    
    console.log(`Main select ${index}: ${selectName} = ${selectedValue}`);
    
    if (selectedValue) {
      // モーダル内の対応するセレクトを探す
      const modalSelect = modalContainer.querySelector(`select[name="${selectName}"]`);
      
      if (modalSelect) {
        console.log('Found modal select, updating to:', selectedValue);
        modalSelect.value = selectedValue;
        
        // 表示も更新
        const modalDropdown = modalSelect.closest('.po-option--dropdown-menu-container');
        if (modalDropdown) {
          const allOptions = modalDropdown.querySelectorAll('.po-dropdown-option');
          
          allOptions.forEach(opt => {
            const optValue = opt.getAttribute('data-value');
            if (optValue === selectedValue) {
              // selected クラスを更新
              allOptions.forEach(o => o.classList.remove('selected'));
              opt.classList.add('selected');
              
              // 表示テキストを更新
              const modalDisplay = modalDropdown.querySelector('.po-dropdown-selected-option');
              if (modalDisplay) {
                const optDesc = opt.querySelector('.po_description');
                if (optDesc) {
                  modalDisplay.innerHTML = optDesc.innerHTML;
                  console.log('Modal display updated');
                }
              }
            }
          });
        }
      } else {
        console.warn('Modal select not found for:', selectName);
      }
    }
  });
  
  console.log('Selections synced to modal');
  
  // イベントリスナーを設定
  setupModalEventListeners();
}

// モーダルのイベントリスナーを設定
function setupModalEventListeners() {
  console.log('Setting up modal OPTIS event listeners...');
  
  const modalContainer = document.getElementById('modalOptisContainer');
  if (!modalContainer) {
    console.error('Modal container not found for event setup');
    return;
  }
  
  // 既存のイベントリスナーがあるかチェック
  const hasEvents = modalContainer.getAttribute('data-events-setup') === 'true';
  console.log('Has events already:', hasEvents);
  
  if (hasEvents) {
    console.log('Events already set up, skipping duplicate setup');
    return; // 既に設定済みなら何もしない
  }
  
  // イベント委譲で設定(一度だけ)
  modalContainer.addEventListener('click', function(e) {
    console.log('Modal container clicked, target:', e.target.className);
    
    // オプションがクリックされた場合
    const optionElement = e.target.closest('.po-dropdown-option');
    if (optionElement) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Modal option clicked via delegation');
      selectModalOptisOption(optionElement);
      return;
    }
    
    // ドロップダウンコンテナがクリックされた場合
    const dropdownElement = e.target.closest('.po-select-dropdown-thumbnail');
    if (dropdownElement) {
      e.stopPropagation();
      console.log('Modal dropdown clicked');
      handleModalOptisDropdown(dropdownElement);
      return;
    }
  }, true);
  
  // 設定済みフラグを立てる
  modalContainer.setAttribute('data-events-setup', 'true');
  
  console.log('Modal event listeners set up (one-time only)');
}

// モーダル内のOPTISドロップダウンを開閉
function handleModalOptisDropdown(element) {
  console.log('=== Handle Modal Dropdown ===');
  
  const dropdownList = element.querySelector('.po-dropdown-list');
  console.log('Dropdown list found:', !!dropdownList);
  
  if (dropdownList) {
    const isVisible = dropdownList.style.display === 'block';
    console.log('Current visibility:', isVisible);
    
    // 他のドロップダウンを閉じる
    document.querySelectorAll('#modalOptisContainer .po-dropdown-list').forEach(list => {
      list.style.display = 'none';
    });
    
    // トグル
    dropdownList.style.display = isVisible ? 'none' : 'block';
    console.log('New visibility:', dropdownList.style.display);
  }
}

// モーダル内のOPTISオプション選択
// モーダル内のOPTISオプション選択
// モーダル内のOPTISオプション選択
function selectModalOptisOption(optionElement) {
  console.log('=== Modal OPTIS Option Selected ===');
  
  const value = optionElement.getAttribute('data-value');
  console.log('Selected value:', value);
  
  if (!value) {
    console.log('No value, returning');
    return;
  }
  
  const dropdown = optionElement.closest('.po-option--dropdown-menu-container');
  const selectedDisplay = dropdown.querySelector('.po-dropdown-selected-option');
  const hiddenSelect = dropdown.querySelector('select');
  const dropdownList = dropdown.querySelector('.po-dropdown-list');
  
  // モーダル内の表示を更新
  dropdown.querySelectorAll('.po-dropdown-option').forEach(opt => {
    opt.classList.remove('selected');
  });
  optionElement.classList.add('selected');
  
  if (selectedDisplay) {
    const descriptionContent = optionElement.querySelector('.po_description');
    if (descriptionContent) {
      selectedDisplay.innerHTML = descriptionContent.innerHTML;
    }
  }
  
  if (hiddenSelect) {
    hiddenSelect.value = value;
    console.log('Modal hidden select updated to:', value);
  }
  
  if (dropdownList) {
    dropdownList.style.display = 'none';
  }
  
  // モーダル内の価格を更新
  setTimeout(() => {
    updateModalTotalPrice();
  }, 100);
  
  // ★★★ 元のページの対応するOPTISオプションを完全に同期 ★★★
  if (hiddenSelect && hiddenSelect.name) {
    const selectName = hiddenSelect.name;
    console.log('=== Syncing to main page ===');
    console.log('Select name:', selectName, 'Value:', value);
    
    // 元のページの対応するセレクトを探す
    const mainSelects = document.querySelectorAll(`select[name="${selectName}"]`);
    
    mainSelects.forEach(mainSelect => {
      if (!mainSelect.closest('#modalOptisContainer') && !mainSelect.closest('#productModal')) {
        console.log('Found main select element');
        
        // 1. セレクトの値を更新
        mainSelect.value = value;
        console.log('Main select value updated');
        
        // 2. changeイベントを発火
        const changeEvent = new Event('change', { bubbles: true });
        mainSelect.dispatchEvent(changeEvent);
        console.log('Change event dispatched');
        
        // 3. inputイベントも発火
        const inputEvent = new Event('input', { bubbles: true });
        mainSelect.dispatchEvent(inputEvent);
        console.log('Input event dispatched');
        
        // 4. 元のページのドロップダウン表示を更新
        const mainDropdown = mainSelect.closest('.po-option--dropdown-menu-container');
        
        if (mainDropdown) {
          console.log('Found main dropdown container');
          
          // 対応するオプションを探す
          const mainOption = mainDropdown.querySelector(`.po-dropdown-option[data-value="${value}"]`);
          
          if (mainOption) {
            console.log('Found main option element');
            
            // selected クラスを更新
            mainDropdown.querySelectorAll('.po-dropdown-option').forEach(opt => {
              opt.classList.remove('selected');
            });
            mainOption.classList.add('selected');
            console.log('Selected class updated');
            
            // 表示テキストを更新
            const mainDisplay = mainDropdown.querySelector('.po-dropdown-selected-option');
            if (mainDisplay) {
              const optDesc = mainOption.querySelector('.po_description');
              if (optDesc) {
                mainDisplay.innerHTML = optDesc.innerHTML;
                console.log('Display text updated');
              }
            }
            
            // 5. オプション要素を実際にクリック
            console.log('Triggering click on main option');
            
            // MouseEventを作成して発火
            const clickEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });
            mainOption.dispatchEvent(clickEvent);
            console.log('Click event dispatched');
            
            // 6. OPTISアプリのグローバル関数を呼び出し(存在する場合)
            if (typeof BSS_PO !== 'undefined') {
              console.log('BSS_PO detected');
              
              // OPTISアプリの価格更新関数を探して実行
              if (typeof BSS_PO.updatePrice === 'function') {
                console.log('Calling BSS_PO.updatePrice');
                BSS_PO.updatePrice();
              }
              
              if (typeof BSS_PO.calculatePrice === 'function') {
                console.log('Calling BSS_PO.calculatePrice');
                BSS_PO.calculatePrice();
              }
              
              if (typeof BSS_PO.updateTotalPrice === 'function') {
                console.log('Calling BSS_PO.updateTotalPrice');
                BSS_PO.updateTotalPrice();
              }
            }
          } else {
            console.error('Main option element not found for value:', value);
          }
        } else {
          console.error('Main dropdown container not found');
        }
      }
    });
    
    console.log('=== Main page sync complete ===');
  }
  
  console.log('=== Modal Option Selection Complete ===');
}



// バリアント変更時の処理
function updateModalVariant() {
  if (!productModalData) return;
  
  const selects = document.querySelectorAll('[id^="ModalOption-"]');
  const options = Array.from(selects).map(select => select.value);
  
  const variant = productModalData.variants.find(v => {
    return options.every((opt, idx) => v.options[idx] === opt);
  });
  
  if (variant && variant.featured_image) {
    const imageUrl = variant.featured_image.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_600x.$1');
    const imageElement = document.getElementById('modalProductImage');
    if (imageElement) {
      imageElement.src = imageUrl;
    }
  }
  
  updateModalTotalPrice();
}

// モーダルの合計価格を更新
function updateModalTotalPrice() {
  if (!productModalData) return;
  
  try {
    const selects = document.querySelectorAll('[id^="ModalOption-"]');
    const options = Array.from(selects).map(select => select.value);
    
    let basePrice = 0;
    
    if (productModalData.selected_or_first_available_variant && productModalData.selected_or_first_available_variant.price) {
      basePrice = productModalData.selected_or_first_available_variant.price;
    } else if (productModalData.variants && productModalData.variants.length > 0) {
      basePrice = productModalData.variants[0].price;
    }
    
    if (options.length > 0 && productModalData.variants) {
      const variant = productModalData.variants.find(v => {
        return options.every((opt, idx) => v.options && v.options[idx] === opt);
      });
      if (variant && variant.price) {
        basePrice = variant.price;
      }
    }
    
    let optisExtraPrice = 0;
    const hiddenSelects = document.querySelectorAll('#modalOptisContainer select[name^="po_"]');
    
    hiddenSelects.forEach(select => {
      const selectedValue = select.value;
      
      if (selectedValue) {
        const dropdown = select.closest('.po-option--dropdown-menu-container');
        if (dropdown) {
          const matchingOption = dropdown.querySelector(`.po-dropdown-option[data-value="${selectedValue}"]`);
          
          if (matchingOption) {
            const priceSpan = matchingOption.querySelector('.po-extra-price');
            
            if (priceSpan) {
              const priceText = priceSpan.textContent.trim();
              const priceMatch = priceText.match(/[+\-]?\s*¥?([\d,]+)/);
              
              if (priceMatch) {
                const price = parseInt(priceMatch[1].replace(/,/g, ''));
                optisExtraPrice += price;
              }
            }
          }
        }
      }
    });
    
    const totalPriceYen = (basePrice / 100) + optisExtraPrice;
    
    const priceElement = document.getElementById('modalTotalPrice');
    if (priceElement) {
      priceElement.textContent = 
        new Intl.NumberFormat('ja-JP').format(totalPriceYen);
    }
    
    modalOptisPrice = optisExtraPrice;
    
  } catch (error) {
    console.error('Error in updateModalTotalPrice:', error);
  }
}

// カート追加
// カート追加
// カート追加
// カート追加
// カート追加
function addToCartFromModal() {
  console.log('=== Adding to Cart from Modal ===');
  
  if (!productModalData) {
    alert('商品データが読み込まれていません');
    return;
  }
  
  // まず、モーダルの選択内容を元のページに同期
  const modalSelects = document.querySelectorAll('#modalOptisContainer select[name^="po_"]');
  
  modalSelects.forEach(modalSelect => {
    const selectName = modalSelect.name;
    const selectedValue = modalSelect.value;
    
    if (selectedValue) {
      // 元のページの対応するセレクトを更新
      const mainSelects = document.querySelectorAll(`select[name="${selectName}"]`);
      
      mainSelects.forEach(mainSelect => {
        if (!mainSelect.closest('#modalOptisContainer')) {
          mainSelect.value = selectedValue;
          
          // changeイベントを発火してOPTISアプリに通知
          const event = new Event('change', { bubbles: true });
          mainSelect.dispatchEvent(event);
        }
      });
    }
  });
  
  console.log('Synced modal selections to main page');
  
  // 少し待ってから元のページのカート追加ボタンをクリック
  setTimeout(() => {
    // 元のページのカート追加ボタンを探す
    const mainAddToCartButton = document.querySelector('button[name="add"]:not(#modalOptisContainer button), .product-form__submit:not(#modalOptisContainer .product-form__submit)');
    
    if (mainAddToCartButton) {
      console.log('Clicking main add to cart button');
      
      // モーダルを閉じる
      closeProductModal();
      
      // 元のページのボタンをクリック
      mainAddToCartButton.click();
    } else {
      console.error('Main add to cart button not found');
      alert('カート追加ボタンが見つかりません');
    }
  }, 500);
}





// 通常の商品ページ用の価格更新
function updateMainProductPrice() {
  console.log('=== Main Product Price Update ===');
  
  if (!productModalData) {
    console.error('productModalData is not defined');
    return;
  }
  
  let basePrice = productModalData.selected_or_first_available_variant.price;
  
  const variantSelects = document.querySelectorAll('select[name^="options"]');
  if (variantSelects.length > 0) {
    const options = Array.from(variantSelects).map(select => select.value);
    const variant = productModalData.variants.find(v => {
      return options.every((opt, idx) => v.options[idx] === opt);
    });
    if (variant && variant.price) {
      basePrice = variant.price;
    }
  }
  
  let optisExtraPrice = 0;
  
  // モーダル外のOPTISセレクトから価格を取得
  const allOptisSelects = document.querySelectorAll('select[name^="po_"]');
  const mainOptisSelects = Array.from(allOptisSelects).filter(select => 
    !select.closest('#modalOptisContainer')
  );
  
  console.log('Main OPTIS selects found:', mainOptisSelects.length);
  
  mainOptisSelects.forEach(select => {
    const selectedValue = select.value;
    console.log('Main OPTIS value:', selectedValue);
    
    if (selectedValue) {
      const dropdown = select.closest('.po-option--dropdown-menu-container');
      if (dropdown) {
        const matchingOption = dropdown.querySelector(`.po-dropdown-option[data-value="${selectedValue}"]`);
        if (matchingOption) {
          const priceSpan = matchingOption.querySelector('.po-extra-price');
          if (priceSpan) {
            const priceText = priceSpan.textContent.trim();
            const priceMatch = priceText.match(/[+\-]?\s*¥?([\d,]+)/);
            if (priceMatch) {
              const price = parseInt(priceMatch[1].replace(/,/g, ''));
              console.log('OPTIS price extracted:', price);
              optisExtraPrice += price;
            }
          }
        }
      }
    }
  });
  
  const totalPrice = (basePrice / 100) + optisExtraPrice;
  console.log('Total price:', totalPrice);
  
  // 価格要素を更新(モーダル以外)
  const allPriceElements = document.querySelectorAll('.price-item.price-item--regular');
  
  allPriceElements.forEach(el => {
    if (!el.closest('#productModal')) {
      const formattedPrice = new Intl.NumberFormat('ja-JP', { 
        style: 'currency', 
        currency: 'JPY' 
      }).format(totalPrice);
      
      el.textContent = formattedPrice;
      console.log('Main price updated to:', formattedPrice);
    }
  });
}

// 通常の商品ページ用の価格更新イベントを設定
function setupMainProductPriceUpdate() {
  console.log('=== Setup Main Product Price Update ===');
  
  // ページ全体のクリックを監視
  document.addEventListener('click', function(e) {
    // OPTISドロップダウンオプションがクリックされた場合
    const optisOption = e.target.closest('.po-dropdown-option');
    if (optisOption && !optisOption.closest('#modalOptisContainer')) {
      console.log('Main OPTIS option clicked');
      setTimeout(() => {
        updateMainProductPrice();
      }, 500);
    }
    
    // OPTISドロップダウンコンテナがクリックされた場合
    const optisContainer = e.target.closest('.po-select-dropdown-thumbnail');
    if (optisContainer && !optisContainer.closest('#modalOptisContainer')) {
      console.log('Main OPTIS container clicked');
      setTimeout(() => {
        updateMainProductPrice();
      }, 500);
    }
  });
  
  // Shopify標準バリアント
  const variantSelects = document.querySelectorAll('select[name^="options"]');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      console.log('Variant changed');
      updateMainProductPrice();
    });
  });
  
  console.log('Main product price update events set up');
}

// モーダル外クリックでドロップダウンを閉じる
document.addEventListener('click', function(e) {
  if (!e.target.closest('.po-select-dropdown-thumbnail')) {
    const modalDropdowns = document.querySelectorAll('#modalOptisContainer .po-dropdown-list');
    if (modalDropdowns) {
      modalDropdowns.forEach(list => {
        list.style.display = 'none';
      });
    }
  }
});
